import React, { useState } from "react";
import { AwesomeButton } from "react-awesome-button";
import { PaperAirplaneIcon } from "@primer/octicons-react";
import 'react-awesome-button/dist/styles.css';
import emailjs from '@emailjs/browser';

import './style.css'
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

export const Contact = () => {

    const handleFocus = ({ target }) => {
        const label = target.previousElementSibling;
        label.classList.add('label-active')
    }
    const handleFocusOut = ({ target }) => {
        if (target.value === '') {
            const label = target.previousElementSibling;
            label.classList.remove('label-active');
        }
    }
    const [name, setName] = useState('');

    const [email, setEmail] = useState('');

    const [subject, setSubject] = useState('');

    const [message, setMessage] = useState('');

    const {register, handleSubmit} = useForm({
        
    })

    const sendEmail = () => {

        const templateParams = {
            name: name,
            email: email,
            subject: subject,
            message: message
        }

        try {
            emailjs.send('service_b6ihaqr', 'template_lo4tovh', templateParams, 'pxvHNhPOhtHMTpOi2')
            toast.success('Email enviado!')
        } catch (error) {
            console.error(error)
            toast.error('Ops, algo deu errado!')
        }
    }

    return (
        <section className="contact" id="Contato">
            <h2 className="titulo-section" data-aos="fade-right">Contato</h2>
            <div className="contentContact" data-aos="fade-up">
                <div className="iconsContact">
                    <a href="https:/wa.me/+5588992710349" target="blank"> <i className="bi bi-whatsapp"></i></a>
                    <a href="https://www.linkedin.com/in/pedro-lisboa-a4b9a0235/" target="blank"><i className="bi bi-linkedin"></i></a>
                </div>
                <p>Contate-me</p>
                <form onSubmit={handleSubmit(sendEmail)} >
                    <div className="label-input">
                        <label htmlFor='name'>Nome<i className="bi bi-person"></i></label>
                        <input {...register('name')} onFocus={handleFocus} onBlur={handleFocusOut} onChange={(e) => setName(e.target.value)} type='text' id="name" name="name" value={name} required />
                    </div>
                    <div className="label-input">
                        <label htmlFor='email'>E-mail<i className="bi bi-at"></i></label>
                        <input {...register('email')} onChange={(e) => setEmail(e.target.value)} onFocus={handleFocus} onBlur={handleFocusOut} type='email' id="email" name="email" required />
                    </div>
                    <div className="label-input">
                        <label htmlFor='assunto'>Assunto<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-message" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"></path>
                            <line x1="8" y1="9" x2="16" y2="9"></line>
                            <line x1="8" y1="13" x2="14" y2="13"></line>
                        </svg></label>
                        <input {...register('subject')} onChange={(e) => setSubject(e.target.value)} onFocus={handleFocus} onBlur={handleFocusOut} type='text' id="assunto" name="_subject" required />
                    </div>
                    <div className="label-input">
                        <label className='label-textarea' htmlFor='mensagem'>Mensagem<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-messages" width="16" height="16" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"></path>
                            <path d="M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"></path>
                        </svg></label>
                        <textarea {...register('message')} onChange={(e) => setMessage(e.target.value)} onFocus={handleFocus} onBlur={handleFocusOut} id="mensagem" name="message" ></textarea>
                    </div>
                    <AwesomeButton type="primary" ref={null} after={<PaperAirplaneIcon />}>Enviar</AwesomeButton>
                </form>
            </div>
        </section >
    )
}